import { apiClient } from "@/api/api-client";

export type BankName = {
    id: number;
    bank_name: string;
};

const bankNameService = {
    list: async (): Promise<BankName[]> => {
        const response = await apiClient.get<BankName[]>("/bank-names");
        return response.data;
    },
};

export default bankNameService;
